import { render } from "./User.vue?vue&type=template&id=d345b05e&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=d345b05e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d345b05e"

export default script